/* global angular */

angular.module('ngTouch', [])

.directive('ngTouchstart', function () {
  'use strict';
  function touchstartCtrl($scope, $element) {
    $element.bind('touchstart', onTouchStart);
    function onTouchStart(event) {
      var method = $element.attr('ng-touchstart');
      $scope.$event = event;
      $scope.$apply(method);
    }
  }
  touchstartCtrl.$inject = ['$scope', '$element'];
  return {
    controller: touchstartCtrl
  };
})

.directive('ngTouchend', function () {
  'use strict';
  function touchendCtrl($scope, $element) {
    $element.bind('touchend', onTouchEnd);
    function onTouchEnd(event) {
      var method = $element.attr('ng-touchend');
      $scope.$event = event;
      $scope.$apply(method);
    }
  }
  touchendCtrl.$inject = ['$scope', '$element'];
  return {
    controller: touchendCtrl
  };
})


;

